// import * as React from 'react';
import Lottie from 'react-lottie';

type Props = {
  anim: object;
  loop: boolean;
  width: number | string;
  height: number | string;
};

export default function LottieControl(props: Props) {
  const { loop, anim, width, height } = props;
  const options = {
    loop,
    autoplay: true,
    animationData: anim,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid',
    },
  };
  return <Lottie options={options} height={height} width={width} />;
}
